import React, { useContext } from 'react'
import Context from '../context/Context'
import HtmlStringElement from './HtmlStringElement'

const Info = () => {
  const context = useContext(Context)

  return (
    <div>
      {(context.customElementContent.INFO_1_HEADING !== '' || context.customElementContent.INFO_1_CONTENT !== '' || context.customElementContent.INFO_1_IMAGE !== '') &&
        <div className="row mt-5">
          {(context.customElementContent.INFO_1_HEADING !== '' || context.customElementContent.INFO_1_CONTENT) !== '' &&
            <div className="col-7 offset-1 col-sm-6 offset-sm-2 text-left">
              {context.customElementContent.INFO_1_HEADING !== '' && <HtmlStringElement elementType={'h3'} html={context.customElementContent.INFO_1_HEADING} />}
              {context.customElementContent.INFO_1_CONTENT !== '' && <HtmlStringElement elementType={'span'} classes={'paragraph-regular-14'} html={context.customElementContent.INFO_1_CONTENT} />}
            </div>
          }
          {context.customElementContent.INFO_1_IMAGE !== '' &&
            <div className="col-3 col-sm-2 text-center">
              <HtmlStringElement html={context.customElementContent.INFO_1_IMAGE} />
            </div>
          }
        </div>
      }
      {(context.customElementContent.INFO_2_HEADING !== '' || context.customElementContent.INFO_2_CONTENT !== '' || context.customElementContent.INFO_2_IMAGE !== '') &&
        <div className="row mt-5">
          {context.customElementContent.INFO_2_IMAGE !== '' &&
            <div className="col-3 offset-1 col-sm-2 offset-sm-2 text-center">
              <HtmlStringElement html={context.customElementContent.INFO_2_IMAGE} />
            </div>
          }
          {(context.customElementContent.INFO_2_HEADING !== '' || context.customElementContent.INFO_2_CONTENT) !== '' &&
            <div className="col-7 col-sm-6 text-left">
              {context.customElementContent.INFO_2_HEADING !== '' && <HtmlStringElement elementType={'h3'} html={context.customElementContent.INFO_2_HEADING} />}
              {context.customElementContent.INFO_2_CONTENT !== '' && <HtmlStringElement elementType={'span'} classes={'paragraph-regular-14'} html={context.customElementContent.INFO_2_CONTENT} />}
            </div>
          }
        </div>
      }
    </div>
  )
}

export default Info
